import { render, staticRenderFns } from "./SubtitleTotals.vue?vue&type=template&id=25fd27af"
import script from "./SubtitleTotals.vue?vue&type=script&lang=js"
export * from "./SubtitleTotals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('25fd27af')) {
      api.createRecord('25fd27af', component.options)
    } else {
      api.reload('25fd27af', component.options)
    }
    module.hot.accept("./SubtitleTotals.vue?vue&type=template&id=25fd27af", function () {
      api.rerender('25fd27af', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SubtitleTotals/SubtitleTotals.vue"
export default component.exports